<div class="keen-slider" #sliderRef [ngStyle]="{ visibility: !slider() ? 'hidden' : 'visible' }" (afterChange)="pauseAfterChange()">
  <div class="gradient left-gradient" [ngClass]="currentSlide() === 0 ? 'arrow--disabled' : ''">
    <button (click)="slider().prev()" class="arrow-button" fill="#ffffff" aria-label="boton-flecha-izquierda">
      <app-left-arrow class="arrow left-arrow" fill="#ffffff"></app-left-arrow>
    </button>
  </div>
  <ng-container *ngIf="noticia?.urlVideo">
    <div class="keen-slider__slide">
      <app-video-noticia #videoComponent [noticia]="noticia"></app-video-noticia>
    </div>
    <ng-container *ngFor="let item of images | slice: 1 : images.length; trackBy: trackByItem; let idx = index">
      <div class="keen-slider__slide">
        <img loading="lazy" [src]="item ? item : ''" [alt]="noticia?.tituloVideo" width="100%" height="100%" (click)="showLightbox(idx + 1)" />
      </div>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="!noticia?.urlVideo">
    <ng-container *ngFor="let item of images; trackBy: trackByItem; let idx = index">
      <div class="keen-slider__slide">
        <ng-container *ngIf="idx === 0; else idxNot0">
          <img ngOptimizedImage [src]="item ? item : ''" [alt]="noticia?.tituloVideo" width="100%" height="100%" (click)="showLightbox(idx)" priority />
        </ng-container>
        <ng-template #idxNot0>
          <img ngOptimizedImage loading="lazy" [src]="item ? item : ''" [alt]="noticia?.tituloVideo" width="100%" height="100%" (click)="showLightbox(idx)" />
        </ng-template>
      </div>
    </ng-container>
  </ng-container>

  <div class="gradient right-gradient" [ngClass]="images.length - 1 === currentSlide() ? 'arrow--disabled' : ''">
    <button (click)="slider().next()" class="arrow-button" fill="#ffffff" aria-label="boton-flecha-derecha">
      <app-right-arrow class="arrow right-arrow" fill="#ffffff"></app-right-arrow>
    </button>
  </div>
  <!-- TODO Input -->
  <ng-container *ngIf="innerHeader">
    <header class="header-noticia header-noticia--type-{{ headerType }}">
      <div class="header-content">
        <h1 class="titulo-noticia" #tituloNoticia>
          {{ noticia?.tituloVideo }}
        </h1>
        <h3 class="entradilla-noticia" #entradillaNoticia [innerHTML]="noticia?.entradillaVideo"></h3>
      </div>
    </header>
  </ng-container>
</div>
<ng-container *ngIf="slider()">
  <app-slider-gallery #gallery [images]="images" [genericAlt]="genericAlt" [parent]="slider()"></app-slider-gallery>
</ng-container>
